export default __webpack_public_path__ + "static/media/mobile3.915eb468.jpg";